import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls an element into view when the address ends in `#<anchor>`: on arrival,
 * and again every time a link to it is followed, including from the page it is
 * already on. A router link does not scroll by itself, and following the same
 * link twice leaves the hash unchanged, so each navigation (its `key`) counts.
 *
 * It waits for `ready`, so the jump happens once the content above the element
 * has its real height rather than landing somewhere that then moves.
 */
export function useScrollToAnchor(anchor: string | null, ready: boolean) {
  const ref = useRef<HTMLDivElement>(null);
  const { hash, key } = useLocation();
  useEffect(() => {
    if (anchor && ready && hash === `#${anchor}`) ref.current?.scrollIntoView();
  }, [anchor, ready, hash, key]);
  return ref;
}
